import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const RHYME_FLIP_ACTIVITY_FRAGMENT = gql `
  fragment RhymeFlipActivityFragment on RhymeFlipActivity {
    targetKey
    rounds {
      letterCombo
      steps {
        id
        answer
        answerImage {
          image {
            ...AssetFragment
          }
        }
        answerAudio {
          audio {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default RHYME_FLIP_ACTIVITY_FRAGMENT;
